var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlackRightArrowIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-icon",
    transform: "translate(0.182)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1183",
    "data-name": "Rectangle 1183",
    width: 28,
    height: 28,
    transform: "translate(-0.182)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Expand_Less",
    d: "M6.465,6.449a.615.615,0,0,1-.861,0L.178,1.038a.608.608,0,0,1,.861-.86l5,4.981L11.029.178a.608.608,0,1,1,.861.86Z",
    transform: "translate(11.525 20.46) rotate(-90)",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Expand_Less-2",
    "data-name": "Expand_Less",
    d: "M6.465,6.449a.615.615,0,0,1-.861,0L.178,1.038a.608.608,0,0,1,.861-.86l5,4.981L11.029.178a.608.608,0,1,1,.861.86Z",
    transform: "translate(11.525 20.46) rotate(-90)",
    stroke: "#000",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackRightArrowIcon);
export default __webpack_public_path__ + "static/media/black-right-arrow-icon.336b8eb2c69c43da2bb2618eb4b2f095.svg";
export { ForwardRef as ReactComponent };